<template>
  <div class="text-left">
    <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
      Enter your bank account information for
      {{
        newPaymentMethodType == 'ach'
          ? 'ACH deposit'
          : newPaymentMethodType == 'wire'
            ? 'wire transfer'
            : ''
      }}.
    </h4>
    <!-- <div class="sm:flex sm:gap-6 sm:mt-2"> -->
    <div class="md:grid md:grid-rows-2">
      <div class="w-full md:flex">
        <form-field
          id="routing_number"
          label="Routing #"
          :value="routing_number"
          placeholder="Enter 9-digit routing #"
          :on-input="handleRoutingNumber"
          name="routing_number"
          pattern="\d*"
          :is-valid="!errorBankAccount"
          error-message="Enter a valid routing number"
        />
        <span class="md:ml-4" />
        <form-field
          label="Bank Name"
          :value="bank"
          placeholder="Bank name"
          :pattern="'number'"
          :show-check="false"
          :disabled="true"
          name="bank_name"
        />

        <p
          v-if="data.errors"
          class="-mt-3 mb-2 text-3xs text-red-500 sm:hidden"
        >
          Account numbers do not match
        </p>
      </div>
      <div class="w-full md:flex">
        <form-field
          label="Account #"
          :value="account_number"
          placeholder="Enter 6-17 digit account #"
          :on-input="handleAccountNumber"
          :pattern="'number'"
          :show-check="false"
          name="account_number"
          :is-valid="!data.errors"
        />
        <span class="md:ml-4" />
        <form-field
          label="Re-Enter Account #"
          :value="verify_account_number"
          placeholder="Re-enter 6-17 digit account #"
          :on-input="handleVerify"
          :pattern="'number'"
          :show-check="false"
          name="verify_account_number"
          :is-valid="!data.errors"
        />
      </div>
      <!-- <div
        class="sm:w-1/2 sm:flex sm:flex-col-reverse"
        :class="{'-mb-2' : data.errors}"
      > -->
      <!-- <div class="flex flex-col">
          <label class="text-left text-2xs font-bold uppercase text-gray-over-dark mb-1">bank name</label>
          <input
            class="p-4 rounded w-full text-sm bg-off-white text-gray-over-dark"
            disabled
            :value="data.payment.bank"
          />
        </div> -->
      <!-- </div> -->
    </div>
    <p
      v-if="data.errors"
      class="-mt-3 hidden text-3xs text-red-500 sm:block"
    >
      Account numbers do not match
    </p>
  </div>
</template>

<script>
import FormField from '../../FormField.vue';
import debounce from 'lodash.debounce';

export default {
  name: 'AchOrWireForm',
  components: {
    'form-field': FormField,
  },
  props: {
    data: Object,
    firstTime: {
      type: [Number, Boolean],
      required: true,
    },
    stepName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      routing_number: '',
      account_number: '',
      verify_account_number: '',
      bank: '',
      errorBankAccount: false,
    };
  },
  computed: {
    isValidForm: function () {
      return this.isValidRoutingNumber() && this.isValidAccountsNumber();
    },
    newPaymentMethodType() {
      return this.$store.state.payments?.newPaymentMethodType;
    },
  },
  mounted() {
    this.$store.commit(
      'addFormDebugMessage',
      'Payment-3 | AchForm | AchOrWireForm mounted'
    );
    if (!this.isValidForm) {
      this.$store.commit('toggleDisabledButton', {
        bool: true,
        source: 'Payment-3 AchForm #1',
      });
    } else {
      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'Payment-3 AchForm #2',
      });
    }
  },
  methods: {
    isNumeric(str) {
      if (typeof str != 'string') return false;
      return !isNaN(str) && !isNaN(parseFloat(str));
    },
    isValidRoutingNumber: function () {
      return (
        this.isNumeric(this.routing_number) && this.routing_number.length === 9
      );
    },
    isValidAccountNumber(account) {
      return (
        this.isNumeric(account) && account.length >= 6 && account.length <= 17
      );
    },
    isValidAccountsNumber() {
      if (this.account_number !== this.verify_account_number) {
        return false;
      }

      if (!this.isValidAccountNumber(this.account_number)) {
        return false;
      }

      return true;
    },
    handleRoutingNumber(e) {
      this.routing_number = e.target.value;

      // If the routing is updated and was not correct, the error must be removed.
      if (this.errorBankAccount) {
        this.bank = '';
        this.errorBankAccount = false;
      }

      if (e.target.value.length < 8) {
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'Payment-3 AchForm #3',
        });
      } else {
        this.debouncedHandleBankName();
      }

      this.onUpdate();
    },
    debouncedHandleBankName: debounce(function () {
      this.handleBankName();
    }, 1000),
    async handleBankName() {
      const res = await this.$store.dispatch(
        'payments/getBankName',
        this.routing_number
      );
      if (res.status === 200) {
        this.bank = res.data.bank_name;
        this.routing_number = res.data.id;
      } else {
        this.errorBankAccount = true;
      }
    },
    handleAccountNumber(e) {
      this.account_number = e.target.value;
      this.onUpdate();
    },
    handleVerify(e) {
      this.verify_account_number = e.target.value;
      this.onUpdate();
    },
    onUpdate() {
      let body = {
        is_active: true,
        routing_number_id: this.routing_number,
        account_number: this.account_number,
        is_type: this.$store.state.payments.newPaymentMethodType,
      };
      this.updateOnboardingPacket(body);
    },
    toggleButton(value) {
      this.$store.commit('toggleDisabledButton', {
        bool: value,
        source: 'Payment-3 AchForm #4',
      });
    },
    updateOnboardingPacket(body) {
      this.$store.dispatch('payments/setPaymentBody', {
        payment_method: body,
      });
    },
  },
  watch: {
    isValidForm: function (isValid) {
      this.$store.commit('toggleDisabledButton', {
        bool: !isValid,
        source: 'Payment-3 AchForm #5',
      });
    },
    verify_account_number: function (nv) {
      this.$store.dispatch('payments/updateNestedField', {
        path: 'errors',
        value: nv !== this.account_number,
      });
      if (nv.length < 6)
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'Payment-3 AchForm #6',
        });
    },
    account_number: function (nv) {
      this.$store.dispatch('payments/updateNestedField', {
        path: 'errors',
        value: nv !== this.verify_account_number,
      });
      if (nv.length < 6)
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'Payment-3 AchForm #7',
        });
    },
    stepName: function (val) {
      // if (val === "Payment-3" && !this.firstTime) {
      if (
        val === 'Payment-3' &&
        ['ach', 'wire'].includes(this.newPaymentMethodType)
      ) {
        if (
          this.account_number?.length > 0 &&
          this.routing_number?.length > 0 &&
          this.verify_account_number?.length > 0
        ) {
          this.onUpdate();
        } else {
          this.toggleButton(true);
        }
      }
    },
  },
};
</script>
